/** 화면 이름 — PageHeader 제목과 엑셀 파일명 접두사(서버 Content-Disposition 파싱 실패 시 폴백)에 함께 쓴다. */
export const SCREEN_TITLE = '재고수불'

/** FilterArea 필드 id — 그대로 폼 값 키가 된다. */
export const FIELD_NAMES = {
  shipperCode: 'shipperCode',
  clsDateRange: 'clsDateRange',
  brandName: 'brandName',
  goodsCode: 'goodsCode',
  warehouseName: 'warehouseName',
} as const

/**
 * 센터명 '전체' 값 — 1.0 ST03 은 ALL 값을 **그대로 서버 전송**했다(ST02 의 ALL→'' 치환과 다른 운영 특이점).
 * 2.0 BE 도 'ALL'/공백 = 전 센터 규약이라(LOGISPRD-9594 §2.2) 동일하게 ALL 을 보낸다.
 */
export const WAREHOUSE_ALL = 'ALL'

/** 조회 기간 상한(일) — BE 2.0 신설 성능 가드(LOGISPRD-9594 §5.1)와 동일. FE 에서 선차단한다. */
export const MAX_SEARCH_DAYS = 31

/**
 * 엑셀 다운로드 행수 상한 — BE `MAX_EXCEL_ROW_SIZE` 와 동일(조회·다운로드 100,000행 통일, 회의 2026-07-10).
 * 1.0 FE 의 50,000행 차단 라인은 폐기됐다. 마지막 조회의 totalCnt 로 선차단하고, 서버도 count 선검사로 400 을 준다.
 */
export const EXCEL_ROW_LIMIT = 100_000

/** 그리드 기본 페이지 크기. */
export const DEFAULT_PAGE_SIZE = 50

/** 그리드 영역 높이(px) — ag-grid 래퍼가 flex-basis 0 이라 부모 높이가 auto 면 0 으로 접힌다. */
export const GRID_HEIGHT = 600

/** 마감일자 파라미터 포맷(yyyyMMdd — BE CLS_DATE_FORMATTER 동일). */
export const CLS_DATE_PARAM_FORMAT = 'YYYYMMDD'

/** 마감일자 표시 포맷 — 디자인 데모 표기(26-08-04). */
export const CLS_DATE_DISPLAY_FORMAT = 'YY-MM-DD'

/** 엑셀 사유 모달의 상세사유 최소 길이 — 1.0 RemarkPop 검증과 동일(옛 ExcelDownloadReasonModal 에서 이관). */
export const REASON_DETAIL_MIN_LENGTH = 5

export const MESSAGES = {
  shipperRequired: '화주명을 선택해 주세요.',
  clsDateRequired: '마감일자를 선택해 주세요.',
  clsDateInvalidRange: '마감일자 시작일이 종료일보다 늦습니다.',
  clsDatePeriodExceeded: `조회 기간은 최대 ${MAX_SEARCH_DAYS}일까지 가능합니다.`,
  /**
   * 새 디자인의 센터명은 멀티셀렉트인데 조회 API `WH_NM` 은 단건 EQUAL 이다(LOGISPRD-9594 §2.2).
   * BE 가 다건(IN)을 받게 되면 이 문구와 index.tsx 의 선차단을 함께 걷어낸다.
   */
  excelReasonRequired: '사유코드를 선택해 주세요.',
  excelReasonDetailTooShort: `상세사유를 ${REASON_DETAIL_MIN_LENGTH}글자 이상 입력해 주세요.`,
  warehouseSingleOnly: '센터명은 한 곳만 선택할 수 있습니다. 여러 센터를 함께 보려면 전체를 선택해 주세요.',
  excelNoRows: '다운로드할 데이터가 없습니다.',
  /** 상품코드 서치헬퍼 — goods-codes 는 무페이징 distinct 라 조건 없는 [조회]는 받지 않고 이 문구로 안내한다(index.tsx enabled). */
  goodsHelperFilterRequired: '브랜드명 또는 상품명을 입력 후 조회해 주세요.',
  helperSearchRequired: '조회 버튼을 눌러 검색해 주세요.',
  excelRowLimitExceeded: `엑셀 다운로드 최대 행수(${EXCEL_ROW_LIMIT.toLocaleString()}행)를 초과했습니다. 조회 조건을 추가해 주세요.`,
} as const

/** 조회영역 필드 키(생성 뷰 st03FilterCard) — [조회] 때 이 값들이 메뉴 세션·URL 에 남고, 진입 조회가 이 키만 복원한다. */
export const FILTER_KEYS = ['SPR_NM', 'st03ClsDate', 'BRD_NM', 'GDS_CD', 'WH_NM'] as const

/**
 * 화주 고정 시 화주명 잠금 + SKU ID 열 플래그 (LOGISPRD-14791, FE 화면 플래그).
 *  ON  — 화주 범위를 공용 `shipperScopeOf`(`shipper_code` 우선 · `FREE_SHIPPERS` 4종 외 잠금)로 판정하고, 그리드 바코드 뒤에 SKU ID 열을 둔다.
 *  OFF — 종전 화면(`is_convertible` · 세션 `SPR_NM`) 그대로다. 조회 실패도 OFF.
 *  BE 의 `feature.stockLedgerSkuIdEnabled`(sku_id 조회)와는 별개 키다 — BE 가 sku_id 를 내리지 않으면 열은 비어 보인다.
 */
export const STOCK_LEDGER_SHIPPER_LOCK_AND_SKU_ID_FLAG = 'feature.stockLedgerShipperLockAndSkuIdEnabled'

/** 그리드 SKU ID 열 폭(px) — 바코드 열(180)과 같다. 플래그 ON 일 때만 쓴다 (LOGISPRD-14791) */
export const SKU_ID_COLUMN_WIDTH = 180
